import { pipe } from "fp-ts/function"
import * as TE from "fp-ts/TaskEither"
import {
  RemoveUserGroupFromTeamDocument,
  RemoveUserGroupFromTeamMutation,
  RemoveUserGroupFromTeamMutationVariables,
  TeamAccessRole,
  UpdateTeamUserGroupRoleDocument,
  UpdateTeamUserGroupRoleMutation,
  UpdateTeamUserGroupRoleMutationVariables,
} from "@app/api/generated/graphql"
import { runMutation } from "@hoppscotch/common/helpers/backend/GQLClient"

type UpdateTeamUserGroupRoleErrors = "team/user_group_not_found"
type RemoveTeamUserGroupRoleErrors = "team/user_group_not_found"

export const updateTeamUserGroupsRole = (
  userGroupID: string,
  teamID: string,
  newRole: TeamAccessRole
) =>
  pipe(
    runMutation<
      UpdateTeamUserGroupRoleMutation,
      UpdateTeamUserGroupRoleMutationVariables,
      UpdateTeamUserGroupRoleErrors
    >(UpdateTeamUserGroupRoleDocument, {
      newRole,
      userGroupID,
      teamID,
    }),
    TE.map(({ updateTeamUserGroupRole }) => updateTeamUserGroupRole)
  )

export const removeTeamUserGroups = (userGroupID: string, teamID: string) =>
  runMutation<
    RemoveUserGroupFromTeamMutation,
    RemoveUserGroupFromTeamMutationVariables,
    RemoveTeamUserGroupRoleErrors
  >(RemoveUserGroupFromTeamDocument, {
    userGroupID,
    teamID,
  })
